import { Anchor, LegacyAnchor } from '@common';
import { faRightFromBracket } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { isLegacyLinkProps } from './helpers';
import { DetailsLegacyLinkPropsType, DetailsLinkPropsType } from './types';

type DetailsType = {
  (props: DetailsLegacyLinkPropsType): React.JSX.Element;
  (props: DetailsLinkPropsType): React.JSX.Element;
};

export const Details: DetailsType = (props) => {
  const { t } = useTranslation('common');
  const label = t('ACTIONS.DETAILS');

  // TODO: Remove isLegacyLinkProps when the transition from php is completed
  if (isLegacyLinkProps(props)) {
    return (
      <Tooltip label={label}>
        <span style={{ display: 'inline-flex' }}>
          <LegacyAnchor href={props.href} aria-label={label}>
            <FontAwesomeIcon icon={faRightFromBracket} />
          </LegacyAnchor>
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip label={label}>
      <span style={{ display: 'inline-flex' }}>
        <Anchor to={props.to} aria-label={label} c="inherit">
          <FontAwesomeIcon icon={faRightFromBracket} />
        </Anchor>
      </span>
    </Tooltip>
  );
};
